import React from "react"
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig"

export const publicRoutes = [
  {
    component: React.lazy(
      () => import("views/auth-views/authentication/login")
    ),
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
  },
  {
    component: React.lazy(
      () => import("views/auth-views/authentication/register")
    ),
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
  },
  {
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password")
    ),
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
  },
]

export const protectedRoutes = [
  {
    component: React.lazy(() => import("views/app-views/dashboards/default")),
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/users/index")
    ),
    key: "users-default",
    path: `${APP_PREFIX_PATH}/users`,
    controller: "user",
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/users/user-form/index")
    ),
    key: "users-default",
    path: `${APP_PREFIX_PATH}/users/:id`,
    controller: "user",
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/users/user-form/index")
    ),
    key: "users-default",
    path: `${APP_PREFIX_PATH}/users/add`,
    controller: "user",
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/medicines/index")
    ),
    key: "medicines-default",
    path: `${APP_PREFIX_PATH}/medicines`,
    controller: "medicine",
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/medicines/imported/index")
    ),
    key: "medicines-default",
    path: `${APP_PREFIX_PATH}/medicines/imported`,
    controller: "medicine",
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/medicines/form/index")
    ),
    key: "medicines-default",
    path: `${APP_PREFIX_PATH}/medicines/add`,
    controller: "medicine",
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/medicines/form/index")
    ),
    key: "medicines-default",
    path: `${APP_PREFIX_PATH}/medicines/:id`,
    controller: "medicine",
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/patients/index")
    ),
    key: "patients-default",
    path: `${APP_PREFIX_PATH}/patients`,
    controller: "patient",
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/patients/form/index")
    ),
    key: "patients-default",
    path: `${APP_PREFIX_PATH}/patients/add`,
    controller: "patient",
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/patients/form/index")
    ),
    key: "patients-default",
    path: `${APP_PREFIX_PATH}/patients/update/:id`,
    controller: "patient",
  },

  {
    component: React.lazy(
      () => import("views/app-views/dashboards/consultations/index")
    ),
    key: "patients-default",
    path: `${APP_PREFIX_PATH}/consultations`,
    controller: "consultation",
  },
  {
    component: React.lazy(
      () =>
        import("views/app-views/dashboards/consultations/ConsultationManage")
    ),
    key: "patients-default",
    path: `${APP_PREFIX_PATH}/consultations/add/:patientId`,
    controller: "consultation",
  },
  {
    component: React.lazy(
      () =>
        import("views/app-views/dashboards/consultations/ConsultationManage")
    ),
    key: "patients-default",
    path: `${APP_PREFIX_PATH}/consultations/:patientId/:id`,
    controller: "consultation",
  },

  {
    component: React.lazy(
      () => import("views/app-views/documents/medical-certificate/index")
    ),
    key: "certificate-default",
    path: `${APP_PREFIX_PATH}/medical-certificate`,
    controller: "medicalCertificate",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/medical-certificate/form/index")
    ),
    key: "certificate-default",
    path: `${APP_PREFIX_PATH}/medical-certificate/add/:patientId`,
    controller: "medicalCertificate",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/medical-certificate/form/index")
    ),
    key: "certificate-default",
    path: `${APP_PREFIX_PATH}/medical-certificate/:id`,
    controller: "medicalCertificate",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/prescription/index")
    ),
    key: "prescription-default",
    path: `${APP_PREFIX_PATH}/prescription`,
    controller: "prescription",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/prescription/form/index")
    ),
    key: "prescription-default",
    path: `${APP_PREFIX_PATH}/prescription/add/:patientId`,
    controller: "prescription",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/prescription/form/index")
    ),
    key: "prescription-default",
    path: `${APP_PREFIX_PATH}/prescription/:id`,
    controller: "prescription",
  },

  {
    component: React.lazy(
      () => import("views/app-views/documents/billans/index")
    ),
    key: "prescription-default",
    path: `${APP_PREFIX_PATH}/bilan`,
    controller: "bilan",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/billans/form/index")
    ),
    key: "prescription-default",
    path: `${APP_PREFIX_PATH}/bilan/add/:patientId`,
    controller: "bilan",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/billans/form/index")
    ),
    key: "prescription-default",
    path: `${APP_PREFIX_PATH}/bilan/:id`,
    controller: "bilan",
  },
  //arret de travaille

  {
    component: React.lazy(
      () => import("views/app-views/documents/arret-travaill/index")
    ),
    key: "prescription-default",
    path: `${APP_PREFIX_PATH}/arret-travail`,
    controller: "workStoppage",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/arret-travaill/form/index")
    ),
    key: "prescription-default",
    path: `${APP_PREFIX_PATH}/arret-travail/add/:patientId`,
    controller: "workStoppage",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/arret-travaill/form/index")
    ),
    key: "prescription-default",
    path: `${APP_PREFIX_PATH}/arret-travail/:id`,
    controller: "workStoppage",
  },

  {
    component: React.lazy(
      () => import("views/app-views/documents/orientation-letter/index")
    ),
    key: "orientation-default",
    path: `${APP_PREFIX_PATH}/orientation-letter`,
    controller: "orientationLetter",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/orientation-letter/form/index")
    ),
    key: "orientation-default",
    path: `${APP_PREFIX_PATH}/orientation-letter/add/:patientId`,
    controller: "orientationLetter",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/orientation-letter/form/index")
    ),
    key: "orientation-default",
    path: `${APP_PREFIX_PATH}/orientation-letter/:id`,
    controller: "orientationLetter",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/justification/index")
    ),
    key: "justification-default",
    path: `${APP_PREFIX_PATH}/justification`,
    controller: "justification",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/justification/form/index")
    ),
    key: "justification-default",
    path: `${APP_PREFIX_PATH}/justification/add/:patientId`,
    controller: "justification",
  },
  {
    component: React.lazy(
      () => import("views/app-views/documents/justification/form/index")
    ),
    key: "justification-default",
    path: `${APP_PREFIX_PATH}/justification/:id`,
    controller: "justification",
  },
  {
    component: React.lazy(
      () => import("views/app-views/schedule/appointments/calendar/index")
    ),
    key: "appointment-default",
    path: `${APP_PREFIX_PATH}/appointments/calendar`,
    controller: "appointment",
  },
  {
    component: React.lazy(
      () => import("views/app-views/schedule/appointments/index")
    ),
    key: "appointment-default",
    path: `${APP_PREFIX_PATH}/appointments`,
    controller: "appointment",
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/expenses/index")
    ),
    key: "expenses-default",
    path: `${APP_PREFIX_PATH}/expenses`,
    controller: "expenses",
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/payments/index")
    ),
    key: "payments-default",
    path: `${APP_PREFIX_PATH}/payments`,
    controller: "payment",
  },

  {
    component: React.lazy(
      () =>
        import(
          "views/app-views/dashboards/consultations/payments/addPayment/index"
        )
    ),
    key: "payments-default",
    path: `${APP_PREFIX_PATH}/payments/add/:consultationId`,
    controller: "payment",
  },
  {
    component: React.lazy(
      () => import("views/app-views/dashboards/typePayments/index")
    ),
    key: "prestations-default",
    path: `${APP_PREFIX_PATH}/prestations`,
    controller: "prestationType",
  },
  {
    component: React.lazy(
      () => import("views/app-views/schedule/reminder/index")
    ),
    key: "reminder-default",
    path: `${APP_PREFIX_PATH}/reminder`,
    controller: "reminder",
  },
  {
    component: React.lazy(
      () => import("views/app-views/schedule/reminder/calendar/index")
    ),
    key: "reminder-default",
    path: `${APP_PREFIX_PATH}/reminder/calendar`,
    controller: "reminder",
  },
  {
    component: React.lazy(
      () => import("views/app-views/schedule/waiting-list/index")
    ),
    key: "waiting-default",
    path: `${APP_PREFIX_PATH}/waiting-list`,
    controller: "waitingList",
  },
  {
    component: React.lazy(() => import("views/app-views/profile/index")),
    key: "profile-default",
    path: `${APP_PREFIX_PATH}/editMyProfil`,
    accessUser: true,
  },
]
